import React, { useContext, useState } from 'react';
import whitelogo from '../assets/img/logo.png';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import athleticimg from '../assets/img/authentic_logo-white.png';
import {
  useNavigate
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppContext } from '../context';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
import {loginSuccess} from '../features/userdataSlice';

function AdminLogin() {

  React.useEffect(() => {
    if (document.body.classList.contains('adminbody_bg')) {
      document.body.classList.remove('body');
    }
    document.body.classList.add('adminbody_bg');
  }, []);

  const [user, setUser] = useState({ email: '', password: '' });
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { storage } = useContext(AppContext);
  const { dispatchStorageEvent } = useContext(AppContext);
  const [errorPassword, setErrorPassword] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [loginval, setloginval] = useState(0);

  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
  });
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    setPasswordVisible(true);
  }
  const handleHideClick = () => {
    setPasswordVisible(false);
  }
  const handleKeypress = (e) => {
    if (e.which === 13) {
      handleSubmit();
      e.preventDefault();
    }
  };

  const changeUserData = (e) => {
    setErrorPassword(false);
    setErrorEmail(false);
    setErrorMsg('');
    var user_temp = { ...user };
    if (e.target.name == 'password') user_temp.password = e.target.value;
    if (e.target.name == 'email') user_temp.email = e.target.value;
    setUser(user_temp);
  }

  const handleSubmit = (event) => {
    setErrorMsg('');
    setSuccessMsg('');
    setErrorPassword(false);
    setErrorEmail(false);

    if(user.email == '' || user.password == '') {
      if (user.password == '') { setErrorPassword(true); }
      if (user.email == '') { setErrorEmail(true); }
      return false;
    }

    setLoader(true);
    Axios.post(`/admin/login`, { email: user.email, password: user.password })
      .then(res => {
        console.log(res.data);
        if (res.data.status == true) {
          dispatch(loginSuccess({ user: res.data.data.user, token: res.data.data.token }));
          //storage[0].userdata = res.data.data.user;
          //secureLocalStorage.setItem("admindata", JSON.stringify(res.data.data.user));
          secureLocalStorage.setItem("token", res.data.data.token);

          //dispatchStorageEvent(storage);
          setSuccessMsg('Admin Login Successfully!');

          setTimeout(function () {
            setLoader(false);
            navigate('/admin/usermanagement');
          }, 1000);
        }
        else {
          setloginval(0);
          setErrorMsg(res.data.message);
          setLoader(false);
        }
      });
  }

  return (
    <>
      <div className='login-sec admin-login-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='login-header'>
              <div className='col-md-12'>
                <img src={whitelogo} alt='logo' />
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='login-content ad-log mt-4'>
                <h2 className='text-center admin-cen-ad'>Admin Login</h2>
              </div>
            </div>
          </div>

          <div className='login-sec-new login-sec-newss'>
            <div className='row'>
              <div className="col-md-12 padding-left">
                <div className='login-sec-page login-sec-pagess'>
                  <div className='login-img'>
                    <img src={athleticimg} />
                  </div>

                  <div className='login-secs login-secsss login-secssss'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <TextField id="standard-basic" label="Email" variant="outlined"
                        name="email"
                        value={user.email} onChange={changeUserData}
                        error={errorEmail}
                        helperText={errorEmail ? 'Please enter your email!' : ''}
                        onKeyPress={handleKeypress}
                      />
                      <span className='login-icon lgn-icn'><EmailIcon /></span>
                    </Box>
                  </div>

                  <div className='login-secs login-secsss login-secssss'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <TextField id="standard-basic" label="Password" variant="outlined"
                        type={passwordVisible ? 'text' : 'password'}
                        name="password"
                        value={user.password} onChange={changeUserData}
                        error={errorPassword}
                        helperText={errorPassword ? 'Please enter your password!' : ''}
                        onKeyPress={handleKeypress}
                      />
                      <span className='login-icon lgn-icn'><LockIcon /></span>
                      <div className='eye-iconsss'>
                        <VisibilityIcon onClick={handleHideClick} style={{ display: passwordVisible ? 'block' : 'none' }} />
                        <VisibilityOffIcon onClick={handleClick} style={{ display: passwordVisible ? 'none' : 'block' }} />
                      </div>
                    </Box>
                  </div>

                  <div className='login-submit'>
                    <button
                      className='btn btn-login btn-login-sumt btn-nsd-sbmit'
                      onClick={handleSubmit} >SUBMIT
                      {
                        loader != '' ?
                          <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                          : ''
                      }
                    </button>
                    {
                      loader != '' ? <div className="success-msg success-login success-new-msg">
                        <p className="success-msg success-login">Please wait while we get you access to the system</p>
                      </div> : <div className="success-msg success-login success-new-msg">
                        <p className="success-msg success-login" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
                      </div>
                    }

                    {
                      errorMsg != '' ? <div className="error-msg error-login" >
                        <p className="error-msg error-login">{errorMsg}</p>
                      </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                        <p className="error-msg error-login">Wrong credentials!</p>
                      </div>
                    }
                    {
                      successMsg != '' ? <div className="success-msg success-login">
                        <p className="success-msg success-login">{successMsg}</p>
                      </div> : ''
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AdminLogin;
